import { render, staticRenderFns } from "./Compare.vue?vue&type=template&id=7aa3724c&"
import script from "./Compare.vue?vue&type=script&lang=ts&"
export * from "./Compare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports